import { ObjetKStatus, enumValue } from '@siclop/kstone-vue'
import { ContractType } from '../enums/ContractType'
import { Person, Organization } from '@siclop/ksadmin-vue'
import type { Profession } from './Profession'

/**
 * Employee model - represents a salaried worker in an organization
 */
export class Employee extends ObjetKStatus {
  personId: number = 0
  person?: Person
  organizationId: number = 0
  organization?: Organization
  professionId?: number
  profession?: Profession
  professionName?: string
  hireDate: string = ''
  terminationDate?: string
  salary: number = 0
  /** Coût horaire (€) : saisi sans la paie, calculé depuis le salaire avec elle. */
  hourlyCost: number | null = null
  contractType: ContractType = ContractType.CDI
  workingHoursPerWeek: number = 35
  workScheduleTemplateId: number | null = null
  workScheduleTemplateName?: string
  positionStartDate: string | null = null
  /** Mode de calcul des RTT propre au salarié (`RttMode`) ; null : celui de l'entreprise. */
  rttMode: number | null = null
  profilePictureId?: number
  profilePictureUrl?: string

  constructor(data?: Partial<Employee>) {
    super(data)
    if (data) {
      this.personId = data.personId ?? 0
      if (data.person) {
        this.person = new Person(data.person)
      }
      this.organizationId = data.organizationId ?? 0
      if (data.organization) {
        this.organization = new Organization(data.organization)
      }
      this.professionId = data.professionId
      this.professionName = data.professionName
      this.hireDate = data.hireDate ?? ''
      this.terminationDate = data.terminationDate
      this.salary = data.salary ?? 0
      this.hourlyCost = data.hourlyCost ?? null
      this.contractType = enumValue(ContractType, data.contractType, ContractType.CDI)
      this.workingHoursPerWeek = data.workingHoursPerWeek ?? 35
      this.workScheduleTemplateId = data.workScheduleTemplateId ?? null
      this.workScheduleTemplateName = data.workScheduleTemplateName
      this.positionStartDate = data.positionStartDate ?? null
      this.rttMode = data.rttMode ?? null
      this.profilePictureId = data.profilePictureId
      this.profilePictureUrl = data.profilePictureUrl
    }
  }

  /**
   * Returns the employee's full name from the associated person
   */
  get fullName(): string {
    return this.person?.fullName ?? ''
  }

  /**
   * Returns true if the employee is currently active (not terminated)
   */
  get isActive(): boolean {
    return !this.terminationDate
  }
}
